import React from 'react';
import UpwardLoaderVector from './UpwardLoaderVector';

// This component covers the wrapper component (need to be position: relative/absolute)
// And displays the loader vector
const UpwardOverlayLoader = (props) => {
   return (
      <div
         style={ {
            position: 'absolute',
            width: '100%',
            height: '100%',
            zIndex: '2000',
            backgroundColor: '#f7f9fb',
            display: 'flex',
            alignContent: 'center',
            justifyContent: 'center',
            alignItems: 'center',
         }}
      >
         <UpwardLoaderVector size={props?.size}/>
      </div>
   )
};

export default UpwardOverlayLoader;
